var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ArrowBack as ArrowBackIcon, LocationOn as LocationOnIcon, Search as SearchIcon, } from "@mui/icons-material";
import { Alert, Autocomplete, Box, Button, Card, CardContent, CircularProgress, Container, IconButton, Stack, TextField, Typography, } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useAddVenueToTeam } from "../api/TeamVenueApiProvider";
import { useSearchVenues } from "../api/VenueApiProvider";
import { useRetrieveTeam } from "../ApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { useNumericParams } from "../utils/useNumericParams";
export var AddVenueToTeam = function () {
    var navigate = useNavigate();
    var teamId = useNumericParams().id;
    var _a = __read(useState(""), 2), searchQuery = _a[0], setSearchQuery = _a[1];
    var _b = useForm({
        defaultValues: {
            venue: null,
            fromDate: dayjs(),
        },
        mode: "onChange",
    }), control = _b.control, handleFormSubmit = _b.handleSubmit, setValue = _b.setValue, _c = _b.formState, errors = _c.errors, isValid = _c.isValid;
    // API hooks
    var _d = useRetrieveTeam({
        id: teamId,
    }), team = _d.data, teamLoading = _d.isLoading;
    var _e = useSearchVenues({
        query: searchQuery,
        enabled: searchQuery.trim().length > 2,
    }), searchResults = _e.data, isSearching = _e.isLoading;
    var addVenueMutation = useAddVenueToTeam({
        teamId: teamId,
        onSuccess: function () {
            navigate("/teams/".concat(teamId, "/venues/"));
        },
        onError: function (error) {
            console.error("Failed to add venue to team:", error);
        },
    });
    var handleVenueSelect = function (venue) {
        setValue("venue", venue);
    };
    var handleSubmit = handleFormSubmit(function (data) {
        if (!data.venue || !teamId) {
            return;
        }
        // Reset any previous error state before starting new mutation
        addVenueMutation.reset();
        addVenueMutation.mutate(__assign({ team: teamId, venue: data.venue.id }, (data.fromDate && { fromDate: data.fromDate.toISOString() })));
    });
    var handleCancel = function () {
        navigate("/teams/".concat(teamId, "/venues/"));
    };
    if (teamLoading) {
        return _jsx(Loading, {});
    }
    if (!team) {
        return _jsx(ErrorView, {});
    }
    return (_jsxs(Container, { maxWidth: "md", sx: { mt: 4, mb: 4 }, children: [_jsx(Box, { sx: { mb: 3 }, children: _jsxs(Box, { sx: { display: "flex", alignItems: "center", gap: 2, mb: 2 }, children: [_jsx(IconButton, { onClick: handleCancel, sx: { p: 0 }, children: _jsx(ArrowBackIcon, {}) }), _jsxs(Typography, { variant: "h4", component: "h1", children: ["Add Venue to ", team.name] })] }) }), _jsx(Card, { children: _jsxs(CardContent, { sx: { p: 4 }, children: [_jsxs(Alert, { severity: "info", sx: { mb: 3 }, children: ["Search for existing venues in our database to add to your team's home venues. If you can't find the venue you're looking for, you may need to", " ", _jsx(Button, { variant: "text", size: "small", onClick: function () { return navigate("/venues/create"); }, sx: { textDecoration: "underline" }, children: "create it first" }), "."] }), _jsx(Box, { component: "form", onSubmit: handleSubmit, children: _jsxs(Stack, { spacing: 3, children: [_jsx(Box, { children: _jsx(Controller, { name: "venue", control: control, rules: { required: "Please select a venue" }, render: function (_a) {
                                                var field = _a.field;
                                                return (_jsx(Autocomplete, __assign({}, field, { options: (searchResults === null || searchResults === void 0 ? void 0 : searchResults.results) || [], getOptionLabel: function (option) {
                                                        return "".concat(option.name, " - ").concat(option.formattedAddress);
                                                    }, renderOption: function (props, option) { return (_jsxs(Box, __assign({ component: "li" }, props, { children: [_jsx(LocationOnIcon, { sx: { mr: 2, color: "text.secondary" } }), _jsxs(Box, { children: [_jsx(Typography, { variant: "body1", children: option.name }), _jsx(Typography, { variant: "body2", color: "text.secondary", children: option.formattedAddress }), option.distance && (_jsxs(Typography, { variant: "caption", color: "text.secondary", children: [parseFloat(option.distance).toFixed(1), " km away"] }))] })] }))); }, inputValue: searchQuery, onInputChange: function (event, newInputValue) {
                                                        setSearchQuery(newInputValue);
                                                    }, onChange: function (event, newValue) {
                                                        field.onChange(newValue);
                                                        handleVenueSelect(newValue);
                                                    }, loading: isSearching && searchQuery.trim().length > 2, loadingText: "Searching venues...", noOptionsText: searchQuery.trim().length <= 2
                                                        ? "Type at least 3 characters to search"
                                                        : "No venues found. Try different search terms or create a new venue.", renderInput: function (params) {
                                                        var _a;
                                                        return (_jsx(TextField, __assign({}, params, { placeholder: "Search for a Log.Soccer venue", helperText: ((_a = errors.venue) === null || _a === void 0 ? void 0 : _a.message) ||
                                                                "Search existing venues by name or address", error: !!errors.venue, InputProps: __assign(__assign({}, params.InputProps), { startAdornment: (_jsx(SearchIcon, { sx: { mr: 1, color: "text.secondary" } })), endAdornment: (_jsxs(_Fragment, { children: [isSearching &&
                                                                            searchQuery.trim().length > 2 ? (_jsx(CircularProgress, { color: "inherit", size: 20 })) : null, params.InputProps.endAdornment] })) }) })));
                                                    } })));
                                            } }) }), _jsx(Box, { children: _jsx(Controller, { name: "fromDate", control: control, rules: {
                                                validate: function (value) {
                                                    if (value && value.isAfter(dayjs())) {
                                                        return "From date cannot be in the future";
                                                    }
                                                    return true;
                                                },
                                            }, render: function (_a) {
                                                var _b;
                                                var field = _a.field;
                                                return (_jsx(DatePicker, __assign({}, field, { label: "Active From Date", maxDate: dayjs(), views: ["year", "month", "day"], openTo: "day", slotProps: {
                                                        textField: {
                                                            fullWidth: true,
                                                            helperText: ((_b = errors.fromDate) === null || _b === void 0 ? void 0 : _b.message) ||
                                                                "When did this venue become your home venue? (Leave blank for today)",
                                                            error: !!errors.fromDate,
                                                        },
                                                        actionBar: {
                                                            actions: ["clear", "today"],
                                                        },
                                                    } })));
                                            } }) }), _jsxs(Box, { sx: { display: "flex", gap: 2, justifyContent: "flex-end" }, children: [_jsx(Button, { variant: "outlined", onClick: handleCancel, disabled: addVenueMutation.isLoading, children: "Cancel" }), _jsx(Button, { type: "submit", variant: "contained", disabled: !isValid || addVenueMutation.isLoading, children: addVenueMutation.isLoading ? (_jsxs(_Fragment, { children: [_jsx(CircularProgress, { size: 20, sx: { mr: 1 } }), "Adding Venue..."] })) : ("Add Venue to Team") })] })] }) })] }) }), _jsx(ErrorSnackbar, { open: addVenueMutation.isError, message: "Failed to add venue to team. Please try again.", onClose: function () { return addVenueMutation.reset(); } })] }));
};
